import { render, staticRenderFns } from "./ModalMove.vue?vue&type=template&id=f7dfb206&scoped=true&"
import script from "./ModalMove.vue?vue&type=script&lang=js&"
export * from "./ModalMove.vue?vue&type=script&lang=js&"
import style0 from "./ModalMove.vue?vue&type=style&index=0&id=f7dfb206&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7dfb206",
  null
  
)

export default component.exports